var render = function render(_c,_vm){return _c('div',_vm._b({staticClass:"administration-header",class:[_vm.data.staticClass, _vm.data.class]},'div',_vm.data.attrs,false),[_vm._t("default"),_c('div',{staticClass:"administration-header__action"},[_vm._t("action")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }